import React from 'react';
import { connect } from 'react-redux';
import { Typography } from '@mui/material';
import { parseStringToInt } from '../../utils/parsing';
import { getSearchParams } from '../../utils/url';
import { Page, Row, Fill } from '../util/Page';
import BuildingsLoader from '../loaders/BuildingsLoader';
import OrganizationsLoader from '../loaders/OrganizationsLoader';
import UsersLoader from '../loaders/UsersLoader';
import ChangelogFilters from './ChangelogFilters';
import OrgBuildingChangelog from './OrgBuildingChangelog';
import useDatedBuildings from './dated-buildings';
import { filterBuildings } from '../../redux/selectors/buildings';

const OrgChangelog = ({ buildingsById, orgId, buildingId }) => {
  const [filters, setFilters, resetFilters] = useDatedBuildings({ orgId, buildingId });
  const buildings = filterBuildings(buildingsById, filters);
  return (
    <Page name="changelog">
      <BuildingsLoader />
      <OrganizationsLoader />
      <UsersLoader />

      <Row>
        <Typography variant="h6">Changelog</Typography>
        <Fill />
        <ChangelogFilters filters={filters} setFilters={setFilters} />
      </Row>
      <Row>
        <OrgBuildingChangelog buildings={buildings} filters={filters} resetFilters={resetFilters} />
      </Row>
    </Page>
  );
};

export default connect(
  (
    {
      entities: {
        buildings: { byId: buildingsById },
      },
    },
    { location: { search } }
  ) => {
    const { org, bid } = getSearchParams(search);
    return {
      orgId: parseStringToInt(org),
      buildingId: parseStringToInt(bid),
      buildingsById,
    };
  }
)(OrgChangelog);
